export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/5d23014a563dca4f7a3a15ddbb31830f.png";